import { render, staticRenderFns } from "./DisclosureAudio.vue?vue&type=template&id=1039b593&"
import script from "./DisclosureAudio.vue?vue&type=script&lang=js&"
export * from "./DisclosureAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports